var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0909 7.7H12.3636V4.2C12.3636 3.08609 11.9039 2.0178 11.0856 1.23015C10.2672 0.442499 9.15731 0 8 0C6.84269 0 5.73278 0.442499 4.91444 1.23015C4.0961 2.0178 3.63636 3.08609 3.63636 4.2V7.7H2.90909C2.13781 7.70081 1.39836 7.99607 0.852983 8.521C0.307605 9.04592 0.000842207 9.75764 0 10.5V18.2C0.000842207 18.9424 0.307605 19.6541 0.852983 20.179C1.39836 20.7039 2.13781 20.9992 2.90909 21H13.0909C13.8622 20.9992 14.6016 20.7039 15.147 20.179C15.6924 19.6541 15.9992 18.9424 16 18.2V10.5C15.9992 9.75764 15.6924 9.04592 15.147 8.521C14.6016 7.99607 13.8622 7.70081 13.0909 7.7ZM10.9091 7.7H5.09091V4.2C5.09091 3.45739 5.3974 2.7452 5.94296 2.2201C6.48852 1.695 7.22846 1.4 8 1.4C8.77154 1.4 9.51148 1.695 10.057 2.2201C10.6026 2.7452 10.9091 3.45739 10.9091 4.2V7.7Z",
    fill: "#2D3035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.51654ac70571f3a9bf4243ab8ce3604d.svg";
export { ForwardRef as ReactComponent };